import { Component } from '@angular/core';

import { GridPanelComponent } from '../grid-panel/grid-panel.component';

@Component({
    selector: 'aa-grid-triple-panel',
    templateUrl: './grid-triple-panel.component.html',
    styleUrls: [
        '../grid-container.constants.scss',
        './grid-triple-panel.component.scss'
    ],
    standalone: false
})
export class GridTriplePanelComponent extends GridPanelComponent
{
}
